import { defineComponent as p, openBlock as o, createElementBlock as l, mergeProps as u, unref as a, renderSlot as v, createElementVNode as e, createCommentVNode as M } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, m = { key: 1 }, V = { key: 2 }, A = { key: 3 }, f = { key: 4 }, k = { key: 5 }, h = {
  name: "ScalarIconCellSignalMedium"
}, _ = /* @__PURE__ */ p({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = Z(s);
    return (i, t) => (o(), l("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      v(i.$slots, "default"),
      a(n) === "bold" ? (o(), l("g", g, t[0] || (t[0] = [
        e("path", { d: "M132,112v88a12,12,0,0,1-24,0V112a12,12,0,0,1,24,0ZM80,140a12,12,0,0,0-12,12v48a12,12,0,0,0,24,0V152A12,12,0,0,0,80,140ZM40,180a12,12,0,0,0-12,12v8a12,12,0,0,0,24,0v-8A12,12,0,0,0,40,180Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (o(), l("g", m, t[1] || (t[1] = [
        e("path", {
          d: "M120,100.7V208H32a8,8,0,0,1-5.66-13.66Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M198.12,25.23a16,16,0,0,0-17.44,3.46l-160,160A16,16,0,0,0,32,216H192a16,16,0,0,0,16-16V40A15.94,15.94,0,0,0,198.12,25.23ZM112,120v80H32Zm80,80H128V104l64-64Z" }, null, -1)
      ]))) : a(n) === "fill" ? (o(), l("g", V, t[2] || (t[2] = [
        e("path", { d: "M198.12,25.23a16,16,0,0,0-17.44,3.46l-160,160A16,16,0,0,0,32,216H192a16,16,0,0,0,16-16V40A15.94,15.94,0,0,0,198.12,25.23ZM192,200H128V104l64-64Z" }, null, -1)
      ]))) : a(n) === "light" ? (o(), l("g", A, t[3] || (t[3] = [
        e("path", { d: "M126,112v88a6,6,0,0,1-12,0V112a6,6,0,0,1,12,0ZM80,146a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V152A6,6,0,0,0,80,146ZM40,186a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0v-8A6,6,0,0,0,40,186Z" }, null, -1)
      ]))) : a(n) === "regular" ? (o(), l("g", f, t[4] || (t[4] = [
        e("path", { d: "M128,112v88a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0ZM80,144a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V152A8,8,0,0,0,80,144ZM40,184a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-8A8,8,0,0,0,40,184Z" }, null, -1)
      ]))) : a(n) === "thin" ? (o(), l("g", k, t[5] || (t[5] = [
        e("path", { d: "M124,112v88a4,4,0,0,1-8,0V112a4,4,0,0,1,8,0ZM80,148a4,4,0,0,0-4,4v48a4,4,0,0,0,8,0V152A4,4,0,0,0,80,148ZM40,188a4,4,0,0,0-4,4v8a4,4,0,0,0,8,0v-8A4,4,0,0,0,40,188Z" }, null, -1)
      ]))) : M("", !0)
    ], 16));
  }
});
export {
  _ as default
};
